import { render, staticRenderFns } from "./HDWY01_Result.vue?vue&type=template&id=936c2484&scoped=true&"
import script from "./HDWY01_Result.vue?vue&type=script&lang=js&"
export * from "./HDWY01_Result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "936c2484",
  null
  
)

export default component.exports